import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

//通用
import common from './common/index.js'

export default new Vuex.Store({
    state: common.state,
    strict: false,
    modules: {
        common
    },
    actions: common.actions,
    plugins: debug ? [
        createLogger({
            // 自动展开输出的 mutations
            collapsed: true, 
            transformer(state) {
                // 输出前对 state 进行转换
                // 比如说只返回一个 sub-tree
                return state.subTree
            }
        })
    ] : []
})